import { SearchAPIResponse, SearchParams } from '../../search.types';
import { StateType } from '../../../state/state.types';
import { reportSearchEndPoint } from '../search.api';

const reportedQuery: string[] = [];

interface CustomWindow extends Window {
  // eslint-disable-next-line camelcase
  original_query?: { source: string } | null;
}

declare let window: CustomWindow;

function getPushedDataDisplayed(response: SearchAPIResponse) {
  return {
    snippet: {
      enterprise: !!response.enterprise,
      legislation: !!response.law,
      keyword: !!response.fiche,
      lawyer: !!response.professional,
      legalBasis: !!response.legalBasisSnippet,
      commentaries: !!response.commentaries && response.commentaries.length > 0,
    },
    suggestion: { keywords: !!response.recommendedKeywords },
  };
}

export function reportSearch(
  response: SearchAPIResponse,
  searchQuery: SearchParams,

  {
    startRequestTime,
    user,
    reason,
  }: { startRequestTime: number; user: StateType['user']; reason: string },
) {
  if (user.trialExpired || user.quotaExceeded) {
    return; // searched was denied
  }

  const end = new Date().getTime();
  const timeRequest = end - startRequestTime;
  const currentQuery = {
    search_result: {
      ...getPushedDataDisplayed(response),
    },
    date_filter_from_query: response.dateFilterFromQuery,
    has_decision_ref: response.hasDecisionRef,
    key: response.key,
    total_hits: response.totalHits,
    processing_time: response.processingTime,
    search_time: response.searchTime,
    user_wait_time: timeRequest,
    autoCorrectedQuery: response.autoCorrectedQuery,
    search_query: {
      query: searchQuery.q,
      chrono: searchQuery.chrono,
      chrono_inverted: searchQuery.chrono_inverted,
      date_from: searchQuery.date_from,
      date_to: searchQuery.date_to,
      date_exact: searchQuery.date_exact,
      type: searchQuery.type,
      filter_on_specific_article_version:
        searchQuery.filter_on_specific_article_version,
      law_article_id: searchQuery.law_article_id,
      sort_nbr_commentaire: searchQuery.sort_nbr_commentaire,
      selected_keywords: searchQuery.selected_keywords,
      eid: searchQuery.eid,
      lid: searchQuery.lid,
      oid: searchQuery.oid,
    },
    source:
      reason === 'original_query' && window.original_query
        ? window.original_query.source
        : 'direct',
  };

  if (currentQuery && !reportedQuery.includes(currentQuery.key)) {
    reportSearchEndPoint({
      ...currentQuery,
      original_query_key: searchQuery.original_query_key
        ? searchQuery.original_query_key
        : currentQuery.key,
      trigger: reason,
    });
    reportedQuery.push(currentQuery.key);
  }
}
